import type { ReactNode } from 'react'
import entStyles from '../../styles/enterprise/EnterpriseOperationalUx.module.scss'

type Props = {
  children: ReactNode
  className?: string
}

/** Home/Reports-aligned workspace shell for Settings, Integrations, Starter Guide. */
export default function EnterpriseOperationalPage({ children, className }: Props) {
  return (
    <div className={`${entStyles.workspace} ${entStyles.onDarkSurface} ${className || ''}`.trim()}>
      {children}
    </div>
  )
}
